import { useLocation } from 'react-router-dom';

/**
 * 現在の表示言語を取得するカスタムフック
 * URL パスの先頭セグメント（/ja または /en）を唯一のソースとして使用し、
 * カテゴリー・タグ付きホーム（/ja?category=xxx など）でも正しく言語を返す。
 * @returns 言語コード（'ja' | 'en'）
 */
export const useLanguage = (): 'ja' | 'en' => {
  const { pathname } = useLocation();

  // パス先頭の言語セグメントを最優先（クエリ付き /ja?category=sample でも pathname は /ja）
  const pathLang = pathname.match(/^\/(ja|en)(?:\/|$)/)?.[1];
  if (pathLang === 'ja' || pathLang === 'en') {
    return pathLang;
  }

  // ルート（/）の場合はブラウザ言語から推定
  if (pathname === '/' || pathname === '') {
    const browserLang = (navigator.language || navigator.languages?.[0] || 'en').toLowerCase().split('-')[0];
    return browserLang === 'ja' ? 'ja' : 'en';
  }

  return 'en';
};

